import {
    SHIPMENT_RECEIVE,
    SHIPMENT_ERROR,
    SHIPMENT_CHANGE_MODE,
    SHIPMENT_CHANGE_CURRENTPAGE,
    SHIPMENT_SET_ORDER
} from '../ConstantsBrafab/constants';

import {
    ViewMode
} from '../constants';

import { error as errorReducer } from '../Reducers/Error.reducer';

const defaultState = {
    mode: ViewMode.List,
    list: [],
    shipment: {},
    totalCount: 0,
    fromDate: null,
    toDate: null,
    maxDate: '',
    errors: {},
};

export const shipment = (state = defaultState, action) => {
    const { type, payload } = action;
    switch (type) {
        case SHIPMENT_RECEIVE:
        case SHIPMENT_CHANGE_MODE:
        case SHIPMENT_CHANGE_CURRENTPAGE:
        case SHIPMENT_SET_ORDER:
            return {
                ...state,
                errors: {},
                ...payload,
            };
        case SHIPMENT_ERROR:
            return {
                ...state,
                errors: errorReducer(state.errors, action),
            };
        default:
            return state;
    }
};